/**
 * @desc 获取多店铺退货列表
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: defs.walmart.ReturnsRequest, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrderReturns/getReturns`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
